import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { DraggableSplit } from '../DraggableSplit/DraggableSplit';
import { ProjectFiles } from '../ProjectFiles/ProjectFiles';
import * as style from './ChatPage.module.less';
import { ChatPanel } from './ChatPanel/ChatPanel';
import { Switch } from '../Switch/Switch';
import { PDFViewerPanel } from '../PDFViewerPanel/PDFViewerPanel';
export const ChatPage = observer(() => {
    const [view, setView] = useState(0);
    const [pdfData, setPdfUrl] = useState({
        url: null,
        displayName: null
    });

    const store = useStore();
    const query = store.query;

    const requestSeeFile = (pdfUrl: string, displayName: string) => {
        setPdfUrl({ url: pdfUrl, displayName: displayName });
        setView(1);
    };

    return (
        <DraggableSplit spaceBetween={30}>
            <Switch activeView={view} onBack={() => setView(0)}>
                <ProjectFiles requestSeeFile={requestSeeFile} />
                <PDFViewerPanel
                    pdfUrl={pdfData.url}
                    title_display={pdfData.displayName}
                />
            </Switch>
            <ChatPanel />
        </DraggableSplit>
    );
});
